var tones = [];

function dialTones(params, callback) {
  let index = -1;
  switch(params.command) {
    case 'Register':
      var id = "tone" + params.id;
      var row = {};
      if(params.type == 'audio') {
        row = document.createElement('audio');
      } else if(params.type == 'video') {
        row = document.createElement('video');
      }
      row.id = id;
      row.controls = 'controls';
      row.style.display = 'none';
      if(!document.getElementById(id)) {
        document.getElementById("mediaElements").appendChild(row);
        tones.push({ Id : params.id, State : 'Registered', Element : document.getElementById(id)});
      }
      
      break;
    case 'UnRegister':
      index = tones.findIndex((tone) => tone.id = params.id);
      if(index != -1) {
        tones.splice(index, 1);
      }
      break;
    case 'Play':
      index = tones.findIndex((tone) => tone.id = params.id);
      if(index != -1) {
        tones[index].Element.loop = params.loop;
        tones[index].Element.src = params.soundFile;
        tones[index].Element.load();
        tones[index].Element.play();

        tones[index].Element.addEventListener('play', (event) => {
          tones[index].State = 'Playing';
          if(callback) {
            callback(null, {State : tones[index].State});
          }

          if(tones[index].Element.loop) {
            let timeOut = params.timeOut || 15;
            setTimeout(()=> {
              tones[index].Element.loop = false;
              tones[index].Element.src = '';
              tones[index].Element.load();
              tones[index].Element.pause();
            }, timeOut * 1000);
          }
        });

        tones[index].Element.addEventListener('ended', (event) => {
          tones[index].State = 'Ended';
          if(callback) {
            callback(null, {State : tones[index].State});
          }
        });
      }
      break;
    case 'Pause':
      index = tones.findIndex((tone) => tone.id = params.id);
      console.log("Got Pause Event", params);
      if(index != -1) {
        if (tones[index].Element.isPlaying) {
          console.log("Tone is playing");
        } else {
          console.log("Tone is already paused");
        }
        tones[index].Element.loop = params.loop;
        tones[index].Element.src = '';
        tones[index].Element.load();
        tones[index].Element.pause();
        console.log("Paused ", params);
        tones[index].Element.addEventListener('pause', (event) => {
          tones[index].State = 'Paused';
          if(callback) {
            callback(null, {State : tones[index].State});
          }
        });
      }
      break;
    default:
      console.log("UnHandled Command : ", params.command);
  }
}

export {
  dialTones
}
